import HomeView from '@/views/HomeView.vue';

const homeRoutes = [
  {
    path: '/',
    name: 'home',
    meta: {
      headerConfig: {
        headerLabel: 'home',
        hide: false,
        showBack: false,
        showProfile: true,
      },
      footerConfig: {
        hide: false,
      },
      securityConfig: {
        requireAuthentication: true,
        rolesAllowed: ['common', 'admin'],
        restaurantRoleAllowed: ['admin', 'manager', 'employee'],
      },
      containerMargins: false,
    },
    component: HomeView,
  },
];

export default homeRoutes;
